import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

import UBXButton from "./../../ubx/button";

export default class LogoutModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userLoggedIn: false,
            email: "",
            password: "",
            formReady: false,
            userId: null,
            error: false,
            isBusy: false,
        };
    }

    closeModal(e) {
        const { close = false } = this.props;

        if (close) {
            close(e);
        }
    }

    onLogout(e) {
        e.preventDefault();

        const { onLogout = false } = this.props;

        if (onLogout) {
            onLogout();
        }

        this.closeModal();

        return false;
    }

    render() {
        const { show = false } = this.props;

        return (
            <Modal
                id="logout-modal"
                className="simple"
                show={show}
                backdrop="static"
                centered
                onHide={(e) => this.closeModal(e)}
            >
                <Modal.Header closeButton closeLabel="Close Login Modal"></Modal.Header>
                <Modal.Body>
                    <div id="user-logout">
                        <form id="logout-form" onSubmit={(e) => this.onLogout(e)}>
                            <p>Are you sure you want to log out now?</p>
                        </form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="logout-buttons">
                        <UBXButton
                            id="logout-button-back"
                            type="secondary"
                            aria-label="Close"
                            // form="logout-form"
                            block="sm"
                            onClick={(e) => this.closeModal(e)}
                        >
                            Back
                        </UBXButton>
                        <UBXButton id="logout-button-submit" type="primary" submit={true} block="sm" form="logout-form">
                            Continue
                        </UBXButton>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}
